export type NotificationFlag =
  | 'METER_HEALTH_SUMMARY'
  | 'INSTALL_HEALTH_SUMMARY'
  | 'LEAK'
  | 'HIGH_USAGE'
  | 'MESSAGES_SEEN_EVENT'
  | 'METER_MODE_ACHIEVED_EVENT'
  | 'INITIAL_METER_HEALTHY_EVENT'
  | 'METER_UNHEALTHY_EVENT'
  | 'METER_HEALTHY_EVENT';

export interface UserAccountUpdateBody {
  note: string; // empty string allowed by us; BE allows string|null
  enabled_email_notifications: NotificationFlag[];
  enabled_sms_notifications: NotificationFlag[];
  // Present only when the caller is changing the user's alert properties. Absent means
  // unchanged on the backend, while [] means every property, so an unloaded or unknown value
  // must never be coerced to [] the way the flag arrays are.
  alert_structure_ids?: string[];
}

export function serializeUserAccountUpdate(input: {
  note?: string | null | undefined;
  emailFlags?: unknown;
  smsFlags?: unknown;
  alertStructureIds?: unknown;
}): UserAccountUpdateBody {
  const email = Array.isArray(input.emailFlags) ? (input.emailFlags as NotificationFlag[]) : [];
  const sms = Array.isArray(input.smsFlags) ? (input.smsFlags as NotificationFlag[]) : [];
  const note = (input.note ?? '').toString().trim();

  const body: UserAccountUpdateBody = {
    note, // always a string per our contract ("" if blank)
    enabled_email_notifications: email,
    enabled_sms_notifications: sms,
  };
  if (Array.isArray(input.alertStructureIds)) {
    body.alert_structure_ids = input.alertStructureIds as string[];
  }
  return body;
}
